import React, { forwardRef, useEffect, useImperativeHandle, useMemo } from 'react';
import { Col } from 'react-bootstrap';
import HeaderEdit from './editing/HeaderEdit';
import ReceiveClientCardEdit from './editing/ReceiveClientCardEdit';
import InputValuesEdit from './editing/InputValuesEdit';
import NegotiatedValuesEdit from './editing/NegotiatedValuesEdit';
import ShipmentDiscountsEdit from './editing/ShipmentDiscountsEdit';
import ShipmentTransferEdit from './editing/ShipmentTransferEdit';
import Text from '../Text';
import Card from '../Card';
import FreightValuesContext, { useFreightValues } from './context';

const FreightValuesRef = forwardRef(({ 
  cargoValue,
  isNational,
  loadingDuplicate,
  totalKm,
  onChangeCustomerFields = () => {}
}, ref) => {
  const { 
    init,
    getValues,
    setCargoValue,
    setInsuranceValueBenner,
    setCustomerFields,
    convertValueToCurrency,
    setTotalKm,
    customerFields,
    errors
  } = useFreightValues();


  useEffect(() => {
    if (onChangeCustomerFields) {
      onChangeCustomerFields(customerFields);
    }
  }, [customerFields?.takerValue?.value]);

  useImperativeHandle(ref, () => ({
    getValues,
    init,
    setInsuranceValueBenner,
    errors,
    setCustomerFields,
    convertValueToCurrency,
  }));

  useEffect(() => {
    setCargoValue(cargoValue);
  }, [cargoValue]);

  useEffect(() => {
    setTotalKm(totalKm);
  }, [totalKm]);

  return (
    <Col xs={12}>
      <Card
        header={<Text type="header">Composição de valores de frete</Text>}
        bodyCardPadding="2rem"
        loading={loadingDuplicate}
      >
        <HeaderEdit isNational={isNational} />
        <ReceiveClientCardEdit />
        <InputValuesEdit />
        <NegotiatedValuesEdit />
        <ShipmentDiscountsEdit disableIssueRate />
        <ShipmentTransferEdit />
      </Card>
    </Col>
  );
});

export default forwardRef(({ 
  cargoValue,
  isNational,
  loadingDuplicate,
  totalKm,
  onChangeCustomerFields = () => {}
}, ref) => {
  return (
    <FreightValuesContext>
      <FreightValuesRef
        ref={ref}
        cargoValue={cargoValue}
        isNational={isNational}
        loadingDuplicate={loadingDuplicate}
        totalKm={totalKm}
        onChangeCustomerFields={onChangeCustomerFields}
      />
    </FreightValuesContext>
  );
});
